import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Delete, Edit, Save } from 'styled-icons/material';

import { ClientContactApi } from '../../api/api-client';
import { DangerBtn, PrimaryBtn, SaveBtn, SecondaryBtn } from './buttons.component';

const Container = styled.form`
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;

  @media(max-width: 1000px) {
      gap: 0.5rem;
      padding: 0.5rem 0.2rem;
      border: 1px solid var(--korbank-purple);
  }
`

const ContentContainer = styled.div`
  font-size: var(--content-size);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;

  @media(min-width: 1000px) {
      gap: 1rem;
  }
`

const Content = styled.span`
  display: block;
`

const ContentValue = styled.span`
    font-weight: bold;
`

const Input = styled.input`
  padding: 3px 10px;

  @media(max-width: 1000px){
    font-size: var(--mini-size);
  }
`

const ButtonsWrapper = styled.div`
  display: flex;
  margin-top: -10px;
  gap: 0.5rem;

  @media(min-width: 1000px) {
      gap: 1rem;
  }
`

const FormFeedback = styled.p`
  color: red;
  font-size: var(--mini-size);
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
`

export const EditableContent = (props) => {

  let content = '';
  let buttons = ''

  const [formVisible, setFormVisible] = useState(false);
  const [serverFeedback, setServerFeedback] = useState('');

  const onEditClick = useCallback(e => {
    setFormVisible(!formVisible)
  }, [formVisible])

  const formik = useFormik({
    initialValues: {
      field: props.content[1],
    },
    validationSchema: Yup.object({
      field: props.validation
    }),
    onSubmit: async (values) => {
      try {
        const result = await new ClientContactApi({ contact: values.field, id: props.id }).patch();
        if (result.status === 200) {
          // fetch again main page
          props.setRefetch(!props.refetch);
          setFormVisible(false);
        }
      } catch (e) {
        setServerFeedback('Błąd zmiany kontaktu');
      }

    },
  });

  if (formVisible) {
    content = <Column>
      <FormFeedback>
        {formik.errors.field ? (
          <>{formik.errors.field}</>
        ) : null}
        {serverFeedback}
      </FormFeedback>
      <Input id="field" {...formik.getFieldProps('field')} />
        <p></p>
    </Column>

    buttons = <ButtonsWrapper>
      {/* submits edit, here formik submission works */}
        <SaveBtn />
      <SecondaryBtn onClick={onEditClick}>Cofnij</SecondaryBtn>
      {/* just deletes record with given id */}
      {/* https://github.com/formium/formik/issues/1610 */}
      <DangerBtn type="button" onClick={async (e) => {
        try {

          const result = await new ClientContactApi({ id: props.id }).delete();
          if (result.status === 200) {
            // fetch again main page
            props.setRefetch(!props.refetch);
          }
        } catch (e) {
          setServerFeedback('Nie można usunąć danych kontaktowych znajdujących się na umowie');
        }

        }}><Delete height="1rem" /> Usuń</DangerBtn>
    </ButtonsWrapper>

  } else {
    content = <ContentValue>{props.content[1]}</ContentValue>
    buttons = <PrimaryBtn onClick={onEditClick}>
        <Edit height="1rem" /> Edytuj
    </PrimaryBtn>
  }

  return (
    <Container onSubmit={formik.handleSubmit}>
      <ContentContainer>
        <Content>{props.content[0]}</Content>
        {content}
      </ContentContainer>
      {buttons}
    </Container>
  )
}

export { FormFeedback }